import { connect } from 'react-redux';
import type { InsiderTradingDataTableProps } from '@/pages/CompanyReport/components/InsiderTradingTransactions';
import { InsiderTradingDataTable } from '@/pages/CompanyReport/components/InsiderTradingTransactions';
import { makeInsiderTradingTransactions } from '@/pages/CompanyReport/components/InsiderTradingTransactions/redux/selectors';

type StateProps = Pick<InsiderTradingDataTableProps, 'data'>;
const makeMapStateToProps = () => {
  const insiderTradingTransactionsSelector = makeInsiderTradingTransactions();
  return (state, ownProps): StateProps => ({
    data: insiderTradingTransactionsSelector(state, ownProps),
  });
};

export default connect(makeMapStateToProps)(InsiderTradingDataTable);
